import { useTheme } from '../../..';
import { ITheme, IUnitFunction } from '../../common/types';

export const createUnitHook = (unitFunction: IUnitFunction<number>) => (
  multiplier?: number
) => {
  const theme: ITheme = useTheme();
  return unitFunction(multiplier)({
    theme,
  });
};
